import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ThemeProvider } from 'next-themes';

import { BeltProvider } from "../../contexts/BeltContext";
import AdminApp from "../../components/admin/AdminApp";
import ReleaseNotesUnsubscribe from "../../components/admin/ReleaseNotesUnsubscribe";
import PwaUpdateToast from "../../components/shared/PwaUpdateToast";
import { applyCachedAdminDisplaySize } from '../../services/adminPreferences';

applyCachedAdminDisplaySize();

function AdminAppStandalone() {
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <BeltProvider>
          <div className="App">
          <BrowserRouter>
            <Routes>
              {/* Public unsubscribe route - no auth required */}
              <Route path="/release-notes/unsubscribe" element={<ReleaseNotesUnsubscribe />} />
              {/* Admin routes nested under /admin */}
              <Route path="/admin/*" element={<AdminApp />} />
              {/* Redirect root to /admin */}
              <Route path="/" element={<Navigate to="/admin" replace />} />
              {/* Catch all other routes and redirect to /admin */}
              <Route path="*" element={<Navigate to="/admin" replace />} />
            </Routes>
            <PwaUpdateToast variant="admin" />
          </BrowserRouter>
        </div>
      </BeltProvider>
    </GoogleOAuthProvider>
    </ThemeProvider>
  );
}

export default AdminAppStandalone;
